import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { PalletizeFulfillmentOrderTemplate } from 'themes/modules/order/pages';

class PalletizeFulfillmentOrder extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <PalletizeFulfillmentOrderTemplate {...this.props} />;
	}
}

export default defaultTemplate(PalletizeFulfillmentOrder);



// WEBPACK FOOTER //
// ./src/modules/order/pages/PalletizeFulfillmentOrder.jsx